/**
 * Test function to verify Google Maps Distance Matrix API is working
 * Call this from browser console: testDistanceAPI()
 */
export const testDistanceAPI = () => {
  if (!window.google?.maps) {
    console.error("Google Maps not loaded");
    return;
  }

  const service = new window.google.maps.DistanceMatrixService();

  // Test with Hyderabad coordinates
  const origin = { lat: 17.385044, lng: 78.486671 };
  const destination = { lat: 17.4456, lng: 78.3488 };

  console.log("Testing Distance Matrix API...");
  console.log("Origin:", origin);
  console.log("Destination:", destination);

  service.getDistanceMatrix(
    {
      origins: [origin],
      destinations: [destination],
      travelMode: window.google.maps.TravelMode.DRIVING,
      unitSystem: window.google.maps.UnitSystem.METRIC,
    },
    (response, status) => {
      console.log("API Status:", status);
      console.log("Full Response:", response);

      if (status === "OK") {
        const element = response.rows[0].elements[0];
        console.log("Element Status:", element.status);

        if (element.status === "OK") {
          console.log("✅ API is working!");
          console.log("Distance:", element.distance.text);
          console.log("Duration:", element.duration.text);
        } else {
          console.error("❌ Element failed:", element.status);
        }
      } else {
        console.error("❌ API call failed:", status);

        if (status === "REQUEST_DENIED") {
          console.error("Possible causes:");
          console.error(
            "1. Distance Matrix API not enabled in Google Cloud Console"
          );
          console.error("2. API key restrictions blocking the request");
          console.error("3. Billing not enabled for the project");
        } else if (status === "OVER_QUERY_LIMIT") {
          console.error("API quota exceeded. Check your Google Cloud Console.");
        }
      }
    }
  );
};

// Make it available globally for testing
if (typeof window !== "undefined") {
  window.testDistanceAPI = testDistanceAPI;
}
